import { render } from "./ContactUs.vue?vue&type=template&id=10ee2b60&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=10ee2b60&lang=css"
import "./ContactUs.vue?vue&type=style&index=1&id=10ee2b60&lang=css"
import "./ContactUs.vue?vue&type=style&index=2&id=10ee2b60&lang=sass&scoped=true"

import exportComponent from "/home/frappe/ONEFM_Landing_page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ee2b60"]])

export default __exports__